// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2019-12-10 17:20:08 +0100 (Tue, 10 Dec 2019) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 106163 $
//  Purpose   : search react-hooks
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import {Actions, Sel} from 'uix/registries'
import {get, dict, size} from 'ldash'
import log from 'uix/logging'
import {useApi, useMemo} from 'uix/hooks'
import {normalize} from 'uix/normalize'

// ---Local imports

// ---Exports

export const useSimpleSearch = ({query, select}) => {
  let result = null
  let {data, error} = useApi(
    'runLuceneSearch',
    {query, select},
    {condition: size(query) > 2, cached: true}
  )

  let normalized_data = useMemo(() => {
    let res = data
    if (data && data.rows) {
      // XXX: we get empty rows here
      let rows = data.rows.filter(r => size(r) > 0)
      res = {...res, rows: normalize(rows)}
    }
    return res
  }, [data])

  if (data) {
    result = normalized_data
  } else if (error) {
    log.warn('error during search')
  }

  return result
}
